// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const upFirstChar = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
